import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './HomeSpecialSection.module.css';
import API_BASE_URL from '../../config/api';

const HomeSpecialSection = () => {
  const { i18n } = useTranslation();
  const [items, setItems] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const lang = i18n.language === 'ar' ? 'ar' : 'en';

    fetch(`${API_BASE_URL}/home?lang=${lang}`, { signal: controller.signal })
      .then(r => r.json())
      .then(data => {
        const section = data.special_section;
        if (section && section.is_active && Array.isArray(section.items)) {
          setItems(section.items);
        } else {
          setItems([]);
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') setItems([]);
      });

    return () => controller.abort();
  }, [i18n.language]);

  if (!items || items.length === 0) return null;

  const isRtl = i18n.language === 'ar';

  return (
    <section className={styles.section} dir={isRtl ? 'rtl' : 'ltr'}>
      <div className={styles.container}>
        {items.map(item => (
          <div
            key={item.id}
            className={`${styles.row} ${item.image_2_url ? styles.twoImages : styles.oneImage}`}
          >
            {item.image_1_url && (
              <div className={styles.imageWrap}>
                <img src={item.image_1_url} alt="" className={styles.image} />
              </div>
            )}

            <p className={styles.body}>{item.body}</p>

            {item.image_2_url && (
              <div className={styles.imageWrap}>
                <img src={item.image_2_url} alt="" className={styles.image} />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeSpecialSection;
